import React from "react";
import { PROGRAMMES, SITE, WHATSAPP_LINK } from "../lib/site-data";
import { Check, Clock, Calendar, ArrowRight } from "lucide-react";

export default function Pricing() {
  return (
    <section
      id="programmes"
      className="py-20 lg:py-28 bg-[#FAFAFA]"
      data-testid="pricing-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-sm font-medium text-[#D97706] uppercase tracking-widest mb-3">
            Programmes & Pricing
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#0F172A] leading-tight">
            Our programmes,
            <br />
            <span className="text-[#1E3A8A]">at a glance.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[#475569] leading-relaxed">
            Four levels, two subjects. Every class capped at 10 students with
            customised feedback and curated notes. No deposit, no registration,
            no material fees.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-7">
          {PROGRAMMES.map((p) => (
            <div
              key={p.id}
              className={`relative bg-white rounded-3xl p-8 lg:p-10 border transition-all hover:-translate-y-1 hover:shadow-lg ${
                p.featured
                  ? "border-[#1E3A8A] shadow-md ring-1 ring-[#1E3A8A]/10"
                  : "border-[#E2E8F0]"
              }`}
              data-testid={`programme-card-${p.id}`}
            >
              {p.featured && (
                <div className="absolute -top-3 left-8 inline-flex items-center gap-1.5 bg-[#D97706] text-white text-xs font-semibold px-3 py-1 rounded-full">
                  PSLE Year
                </div>
              )}
              <div className="text-sm font-medium text-[#475569] mb-2">
                {p.subjects}
              </div>
              <h3 className="font-heading text-2xl font-semibold text-[#1E3A8A]">
                {p.level}
              </h3>

              <div className="mt-6 space-y-3">
                <div className="flex items-center gap-2 text-sm text-[#0F172A]">
                  <Calendar className="w-4 h-4 text-[#1E3A8A]" />
                  {p.sessions}
                </div>
                <div className="flex items-center gap-2 text-sm text-[#0F172A]">
                  <Clock className="w-4 h-4 text-[#1E3A8A]" />
                  {p.duration}
                </div>
              </div>

              <div className="my-7 h-px bg-[#E2E8F0]" />

              <ul className="space-y-3">
                {p.perks.map((perk) => (
                  <li
                    key={perk}
                    className="flex items-start gap-3 text-sm text-[#0F172A]"
                  >
                    <Check className="w-4 h-4 text-[#1E3A8A] mt-0.5 flex-shrink-0" />
                    <span>{perk}</span>
                  </li>
                ))}
              </ul>

              <a
                href={WHATSAPP_LINK(
                  `Hi ${SITE.name}, I'd like to enroll my child in ${p.level} (${p.subjects}).`
                )}
                target="_blank"
                rel="noopener noreferrer"
                className={`mt-8 inline-flex w-full items-center justify-center gap-2 px-6 py-3 rounded-full font-medium transition-all ${
                  p.featured
                    ? "bg-[#1E3A8A] text-white hover:bg-[#1E40AF] shadow-md"
                    : "bg-white text-[#1E3A8A] border border-[#1E3A8A] hover:bg-[#1E3A8A] hover:text-white"
                }`}
                data-testid={`enroll-${p.id}-btn`}
              >
                Enrol now
                <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          ))}
        </div>

        <p
          className="text-center text-sm text-[#475569] mt-10 max-w-2xl mx-auto"
          data-testid="pricing-fee-note"
        >
          Please refer to the registration form for more details on course fees.
        </p>
      </div>
    </section>
  );
}
